import React, { useState } from "react";
import Creatable from "react-select/creatable";
import { useSelector } from "react-redux";
import { useFeatureFlag } from "../../../../../Api/hooks";
import { getCurrentEnvironment } from "../../../../../Selectors/app";

/**
 * This is the custom cell editor for a string type feature flag. It is special
 * because it will recommend other string values used for the flag in other
 * companies but allow the user to create a new string that is not in the list.
 */
export const CustomStringCellEditor = (props) => {
	const { data, onValueChange, stopEditing } = props;

	const flagId = props.colDef.data._id;

	const [value, setValue] = useState({ value: props.value, label: props.value });
	const environment = useSelector(getCurrentEnvironment);
	const featureFlagRequest = useFeatureFlag(environment.name, flagId);

	if (!featureFlagRequest.data) {
		return <div>Loading...</div>;
	}

	const options = featureFlagRequest.data.featureFlag.options.elements.map((element) => ({
		value: element,
		label: element === "" ? "(Blank)" : element,
	}));

	return (
		<div style={{ width: "200px" }}>
			<Creatable
				defaultValue={value}
				name={`${data._id}-value`}
				options={options}
				isSearchable={true}
				onChange={(option) => {
					setValue(option);
					onValueChange(option.value);
					stopEditing();
				}}
			/>
		</div>
	);
};
